import React from "react";
import TermsAndPrivacyTable from "./Componates/TermsAndPrivacyTable";
import SocialLinksTable from "./Componates/SocialLinkTable";
import ServiceLinksTable from "./Componates/ServiceLinksTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const Footer = () => {

  return (
    <PageBody card={false}>
      {/* Terms and Privacy Section */}
      <div className="col-12 mb-5">
        <PageBody
          card={true}
          headerchildren={
            <>
              <HeadingOne>Terms and Privacy</HeadingOne>
            </>
          }
        >
          <TermsAndPrivacyTable />
        </PageBody>
      </div>

      {/* Service Links Section */}
      <div className="col-12 mb-5">
        <PageBody
          card={true}
          headerchildren={
            <>
              <HeadingOne>Service Links</HeadingOne>
              <AddItemBtn
                url={`add-service-links`}
                title="Add Service Links"
              />
            </>
          }
        >      
          <ServiceLinksTable />
        </PageBody>
      </div>

      {/* Social Links Section */}
      <div className="col-12">
        <PageBody
          card={true}
          headerchildren={
            <>
              <HeadingOne>Social Links</HeadingOne>
              <AddItemBtn
                url={`add-social-link`}
                title="Add Social Link"
              />
            </>
          }
        >
          <SocialLinksTable />
        </PageBody>
      </div>
    </PageBody>
  );
};

export default Footer;
